import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Caso } from '../../casos/casos.model';
import urlJoin from 'url-join';
import { environment } from 'src/environments/environment';
import { NotificationsService } from '../../core/service/notifications.service';

// directives
import { SortDirection } from './sortable.directive';


interface State {
  page: number;
  pageSize: number;
  searchTerm: string;
  sortColumn: string;
  sortDirection: SortDirection;
  startIndex: number;
  endIndex: number;
  totalRecords: number;
}


@Injectable({
  providedIn: 'root'
})
export class AdvancedTableService {

  // tslint:disable-next-line: variable-name
  private _state: State = {
    page: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: '',
    sortDirection: '',
    startIndex: 1,
    endIndex: 0,
    totalRecords: 0,
  };
  constructor(
    private http: HttpClient,
    private notificationsService: NotificationsService
  ) { }

  /**
   * Returns the value
   */
  get page() { return this._state.page; }
  get pageSize() { return this._state.pageSize; }
  get searchTerm() { return this._state.searchTerm; }
  get startIndex() { return this._state.startIndex; }
  get endIndex() { return this._state.endIndex; }
  get totalRecords() { return this._state.totalRecords; }


  /**
   * set the value
   */
  set page(page: number) { this._set({ page }); }
  set pageSize(pageSize: number) { this._set({ pageSize }); }
  set searchTerm(searchTerm: string) { this._set({ searchTerm }); }
  set sortColumn(sortColumn: string) { this._set({ sortColumn }); }
  set sortDirection(sortDirection: SortDirection) { this._set({ sortDirection }); }
  set startIndex(startIndex: number) { this._set({ startIndex }); }
  set endIndex(endIndex: number) { this._set({ endIndex }); }
  set totalRecords(totalRecords: number) {
    this._set({ totalRecords });
  }


  private _set(patch: Partial<State>) {
    Object.assign(this._state, patch);
  }

  private variosURL: string = urlJoin(environment.apiURL, 'varios')

  getCasosXSL(tipoInforme: string): Observable<HttpResponse<Blob>> {
    const getInformeURL = this.variosURL + "/informes" + "?" + tipoInforme;
    console.log(getInformeURL)
    return this.http.get(getInformeURL, { responseType: 'blob', observe: 'response' }).pipe(
      tap(() => {
        this.notificationsService.showSuccessNotification("La descarga comenzará en unos segundos");
      }),
      catchError(error => {
        this.notificationsService.showErrorNotification(error);
        return throwError(() => error);
      })
    );
  }
  
}
